import { Owner } from '../models/chat';

export type LightboxItem = {
    id: any;
    name?: string;
    download_url?: string;
    preview_url?: string;
    created_at?: string;
    owner?: Owner;
    file_mimetype: string;
};

export class LightboxService {
    static $inject = ['$uibModal'];

    constructor(private $uibModal: any) {}

    isImage(mimetype: string) {
        return mimetype.startsWith('image/');
    }

    isVideo(mimetype: string) {
        return mimetype.startsWith('video/');
    }

    isPdf(mimetype: string) {
        return mimetype.startsWith('application/pdf');
    }

    isSupported(mimetype: string) {
        return [this.isImage(mimetype), this.isVideo(mimetype), this.isPdf(mimetype)].includes(true);
    }

    getIcon(mimetype: string) {
        switch (mimetype) {
            // xyards
            case 'xyards':
            case 'application/xyards':
            case 'xyards+analysis':
            case 'application/xyards.analysis+xml':
            case 'xyards+setup':
            case 'application/xyards.setup+xml':
            // xtasytrader
            case 'xtasytrader':
            case 'application/xtasytrader':
            case 'xtasytrader+analysis':
            case 'application/xtasytrader.analysis+xml':
            case 'xtasytrader+setup':
            case 'application/xtasytrader.setup+xml':
            // -
            case 'application/agenatrader.setup+xml':
            case 'application/agenatrader.analysis+xml':
                return '/img/documents/64x64/icon_at.png';
            case 'application/pdf':
                return '/img/documents/64x64/icon_pdf.png';
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                return '/img/documents/64x64/icon_doc.png';
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                return '/img/documents/64x64/icon_xls.png';
            case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                return '/img/documents/64x64/icon_ppt.png';
            case 'application/zip':
                return '/img/documents/64x64/icon_zip.png';
            case 'application/x-rar-compressed':
                return '/img/documents/64x64/icon_rar.png';
            case 'application/x-7z-compressed':
                return '/img/documents/64x64/icon_7z.png';
            case 'application/x-bzip2':
                return '/img/documents/64x64/icon_bz2.png';
            case 'application/x-tar':
                return '/img/documents/64x64/icon_tar.png';
            case 'application/x-gtar':
                return '/img/documents/64x64/icon_tar.gz.png';
            case 'application/gzip':
                return '/img/documents/64x64/icon_gz.png';
            case 'application/octet-stream':
            case 'text/x-csharp':
                return '/img/documents/64x64/icon_cs.png';
            default:
                return '/img/documents/64x64/icon_file.png';
        }
    }

    open(item: LightboxItem) {
        this.$uibModal.open({
            animation: true,
            component: 'tyLightbox',
            windowClass: 'lightbox_modal',
            windowTopClass: 'lightbox_modal',
            resolve: {
                items: () => [item],
            },
        });
    }

    openGallery(items: LightboxItem[], startWith: LightboxItem) {
        this.$uibModal.open({
            animation: true,
            component: 'tyLightbox',
            windowClass: 'lightbox_modal',
            windowTopClass: 'lightbox_modal',
            resolve: {
                items: () => items,
                current: () => startWith.id,
            },
        });
    }
}

angular.module('tradersyard').service('LightboxService', LightboxService);
